import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import LazyLoad from "vanilla-lazyload";

const taxUsedMachineryCat = {
  init() {
    this.events();
  },

  events() {
    $(".filter__slider")
      .children("div")
      .each(function () {
        var el = $(this);
        taxUsedMachineryCat.slider(el);
      });

    $(".filter__slider").on("change", function () {
      taxUsedMachineryCat.handleFilter();
    });

    $(".filter-wrapper")
      .find("select")
      .on("change", function () {
        taxUsedMachineryCat.handleFilter();
      });

    // Handle quantity to show.
    $(document).on("change", "#quantitySelect", function () {
      const value = $(this).val();
      const baseUrl = $(this).data("baseurl");
      window.location = baseUrl + "?display=" + value;
    });

    // Handle accordion
    $(".contact-accordion__toggle").on("click", function () {
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });

    // Handle model filter
    $("[name=brand]").on("change", function () {
      const brand = $(this).val();
      const modelEl = $("[name=model]");

      if ("default" == brand) {
        modelEl.prop("disabled", true);
        modelEl.find("option").show();
      } else {
        modelEl.prop("disabled", false);
        modelEl.find("option").hide();
        modelEl.find(`option[data-brand="${brand}"]`).show();
        modelEl.find(`option[value=default]`).show();
      }
    });
  },

  slider(el) {
    const min = el.data("min");
    const max = el.data("max");

    var pips = {};
    var format = {
      to: (v) => v | 0,
      from: (v) => v | 0,
    };
    var step = 1;
    noUiSlider.create(el[0], {
      range: {
        min: min,
        max: max,
      },
      start: [min, max],
      tooltips: false,
      connect: true,
      step: step,
      // pips: pips,
      format: format,
    });

    el[0].noUiSlider.on("update", function (values, handle) {
      if (values.length > 0) {
        $(this.target).parent().parent().find(".min").html(values[0]);
        $(this.target).parent().parent().find(".max").html(values[1]);
        // setTimeout(() => {
        //   taxUsedMachineryCat.handleFilter();
        // }, 1000);
      }
    });

    el[0].noUiSlider.on("change", function (values, handle) {
      if (values.length > 0) {
        setTimeout(() => {
          taxUsedMachineryCat.handleFilter();
        }, 1000);
      }
    });
  },

  handleFilter() {
    $(".reset-filters").removeClass("not-active");

    const formEl = $("#filter-form");

    const formData = new FormData(formEl[0]);

    const perPage = $("#quantitySelect").val() ?? 6;

    formData.append("per_page", perPage);

    const yearMin = $(".filter__slider--year")
      .find(".noUi-handle-lower")
      .attr("aria-valuenow");
    const yearMax = $(".filter__slider--year")
      .find(".noUi-handle-upper")
      .attr("aria-valuenow");
    if (yearMin !== yearMax) {
      formData.append("year_min", yearMin);
      formData.append("year_max", yearMax);
    }

    // Price
    const priceSliderEl = $(".filter__slider--price");
    const priceMin = priceSliderEl
      .find(".noUi-handle-lower")
      .attr("aria-valuenow");
    const priceMax = priceSliderEl
      .find(".noUi-handle-upper")
      .attr("aria-valuenow");

    if (priceMin !== priceMax) {
      if (priceMin > priceSliderEl.data("min")) {
        formData.append("price_min", priceMin);
      }
      if (priceMax < priceSliderEl.data("max")) {
        formData.append("price_max", priceMax);
      }
    }

    $(".product-list").addClass("loading");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          $(".category-content").html(response.data.posts);
          $(".pagination-wrapper").html(response.data.pagination);
          new LazyLoad();
        }
      })
      .always(() => {
        $(".product-list").removeClass("loading");
      });
  },
};

export default taxUsedMachineryCat;
